import Api from '../../library/api';
import { showError } from '../snackbars/snackbars-actions';

export const REQUEST_BUSINESS_ACCOUNTS = 'REQUEST_BUSINESS_ACCOUNTS';
export const SET_BUSINESS_ACCOUNTS = 'SET_BUSINESS_ACCOUNTS';

export function getBusinessAccounts() {
  return dispatch => {

    dispatch({type: REQUEST_BUSINESS_ACCOUNTS});

    Api.post('p/admin/business-accounts')
      .then(resp => {

        if (resp.err) {
          dispatch(showError(resp.err));
          return
        }

        const byId = {};

        for (const business of resp) {
          byId[business.id] = business
        }

        dispatch({
          type: SET_BUSINESS_ACCOUNTS,
          payload: {
            list: resp,
            byId: byId
          }
        })

      })

  }
}


// WEBPACK FOOTER //
// ./src/components/business-accounts/business-accounts-actions.js